import React from "react";
import "../../assets/css/MissionVision.css";

function MissionVisionPage() {
    return (
      <section className="mission-vision-section">
        <div className="mission-vision-container">
          {/* Left Section: Mission & Vision */}
          <div className="mission-vision-column left animated-left">
            <div className="mission-vision-title">
              <span>Our Mission</span>
            </div>
            <p>
              We hold niche expertise and experience in providing solutions for
              complex IT projects and integrating emerging technologies in a
              dynamic environment.
            </p>
            <div className="mission-vision-title">
              <br></br>
              <span>Our Vision</span>
            </div>
            <p>
              Our cutting-edge services make us a seamless extension of our
              clients. With our dynamic, scalable, resilient, and responsive
              offerings, we ensure rapid growth and high value for our clients.
            </p>
            <div className="mission-vision-button">
              <a href="/about/">Read More</a>
            </div>
          </div>
  
          {/* Right Section: Single Image */}
          <div className="mission-vision-column right animated-right">
            <div className="mission-vision-image">
              <img
                src="https://techtotalers.in/wp-content/uploads/2024/05/about-3-2.jpg"
                alt="About Us"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
  
  export default MissionVisionPage;
  